import { render, staticRenderFns } from "./NewSurplusForm.vue?vue&type=template&id=5490f302&scoped=true"
import script from "./NewSurplusForm.vue?vue&type=script&lang=js"
export * from "./NewSurplusForm.vue?vue&type=script&lang=js"
import style0 from "./NewSurplusForm.vue?vue&type=style&index=0&id=5490f302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5490f302",
  null
  
)

export default component.exports